import React, { useEffect, useMemo, useState } from 'react';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import GeneralLayout from '../app/GeneralLayout';
import PrivateRoute from '../app/PrivateRoute';
import { selectUserProfile } from '../store/selectors/profile.selectors';
import { selectUserOrganization } from '../store/selectors/store.selectors';
import PublicLayout from '../app/PublicLayout';
import AccountVerified from '../auth/containers/AccountVerified';
import { selectOrgHierarchySelectedOrg } from '../store/selectors/orgHierarchy.selectors';

const PrivateRouting = () => {
  const [userFlagsReady, setUserFlagsReady] = useState(false);
  const client = useLDClient();
  const profile = useSelector(selectUserProfile);
  const org = useSelector(selectUserOrganization);
  const selectedOrg = useSelector(selectOrgHierarchySelectedOrg);
  const {
    enableChargebeeModule,
  } = useFlags();


  useEffect(() => {
    if (!isEmpty(profile) && !isEmpty(org)) {
      // Update this identity object to provide additional options to LaunchDarkly to calculate flags upon
      const identity = {
        key: String(profile.id),
        anonymous: false,
        custom: {
          orgId: profile.orgId,
          roles: profile.roles,
          orgTags: org.tags,
          referrerOrgId: org.referrer_org_id,
          parentOrgId: selectedOrg?.parent_id,
          hierarchy: selectedOrg?.hierarchy || org?.hierarchy,
        },
      }
      client.identify(identity)
        .then(() => setUserFlagsReady(true))
        .catch(() => setUserFlagsReady(false));
    }
  }, [profile, org, selectedOrg])

  const isNotAllowed = useMemo(() => {
    return (isEmpty(org?.billing_subscription) && enableChargebeeModule);
  }, [org, profile, enableChargebeeModule]);

  return (
    <PrivateRoute path="*">
      <>
        {
          userFlagsReady && org && (
            (isNotAllowed) ? (
              <PublicLayout>
                <AccountVerified />
              </PublicLayout>
            ) : (
              <GeneralLayout />
            )
          )
        }
      </>
    </PrivateRoute>
  );
};

export default PrivateRouting;
